import { Config } from "../../../personal-studio-components/service/Config.js";
import { Locale } from "../../../personal-studio-components/frame/Locale.js";
export { Config, Locale, StudentService };
Config.setPath("/personal-studio/config.json?_=" + new Date().getTime());
const StudentService = Config.createService("student_service");
